<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="part-one-different-worlds">
<p style="text-align: center; padding-top:150px;">Dear reader, are you aware of the word ‘hate’?</p>
<br/>
<p style="text-align: center;">Hate is pointless and vain</p>
<p style="text-align: center;">But it is for a reason</p>
<p style="text-align: center;">Every person goes through certain adversities</p>
<p style="text-align: center;">Some let it destroy them.</p>
<p style="text-align: center;">Something perhaps devastating and soul-crushing</p>
<p style="text-align: center;">Welcome to the story that is just that!</p>
<p style="text-align: center;">Welcome to the story that seems like there is pointless suffering</p>
<p style="text-align: center;">Nothing is pointless</p>
<p style="text-align: center;">Hate, love, fear, nothing is</p>
<p style="text-align: center;">Welcome to the story in which you will understand my suffering</p>
<p style="text-align: center;">So if they read this,</p>
<p style="text-align: center;">This is my downfall</p>
<p style="text-align: center;">This is the real world</p>
<p><strong><br/>
</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?6ac5de8a